"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styles = void 0;
var _react = require("@linaria/react");
const Styles = exports.Styles = /*#__PURE__*/(0, _react.styled)('li')({
  name: "Styles",
  class: "su2ar2x",
  propsAsIs: false
});